<template>
  <div>
    <AttrGroup
      v-if="
        editorStore.theme?.type == 'normal' && canUse('multi-color-group').valid
      "
      title="样式配色"
    >
      <AttrColor
        :value="themeColor"
        :label="'样式主题色'"
        :alpha-hidden="true"
        :disabled="editorStore.theme?.type != 'normal'"
        @change="onChange"
      />
    </AttrGroup>
  </div>
</template>

<script setup lang="ts">
import { useThemeManage } from '@/hooks';
import { useEditorStore } from '@/store/use-editor-store';
import { computed, nextTick, ref, watch } from 'vue';
import { ColorInputWithoutInstance } from 'tinycolor2';
import tinycolor from 'tinycolor2';
import { notification } from 'ant-design-vue';
import { canUse } from '@/utils/can-use.utils';

const { updateThemeColorAttr } = useThemeManage();

const editorStore = useEditorStore();
const pureColor = ref<ColorInputWithoutInstance>('white');

const themeColor = computed(() => editorStore.themeColor?.color ?? '#ffffff');

watch(
  () => editorStore.themeColor,
  () => {
    pureColor.value = themeColor.value;
  },
  {
    immediate: true,
    deep: true
  }
);

const testExists = (_color: string) => {
  const exists = editorStore.theme?.colorGroupTable
    .filter((item) => item.id !== editorStore.themeColor?.id)
    .some((item) => item.color == _color);
  return !!exists;
};

const onChange = async (val: ColorInputWithoutInstance) => {
  const color = tinycolor(val);
  const hex = color.toHex8().substring(0, 6);
  const _color = '#' + hex;

  if (!editorStore.themeColor || !editorStore.theme) return;
  if (testExists(_color) == true) {
    notification.warning({
      message: '设置失败',
      description: '该样式下已存在此色值，无法重复设置'
    });
    await nextTick();
    pureColor.value = themeColor.value;
  } else {
    updateThemeColorAttr(editorStore.theme, editorStore.themeColor.id ?? '', {
      color: _color
    });
  }
};
</script>

<style scoped lang="less"></style>
